export class savePayorMap {
    id: string;
    payerId: string;
    serviceId: string;
    atypical: boolean;
    renderingProviderLid: string;
    g2Id: string;
    waiver: boolean = false;
    combineClaim: boolean = false;
}


export class getPayorMap {
    id: string;
    payerId: string;
    payerName: string;
    groupLid: string;
    groupName: string;
    serviceId: string;
    serviceDescription: string;
    atypical: boolean;
    renderingProviderLid: string;
    renderingProviderLovName: string;
    g2Id: string;
    agencyId: string;
    currentpageno: number = 1;
    pageitem: number = 10;
    orderColumn: string = "payerName";
    orderType: string;
    type: string = "string";
    field: string = "payerName";
    operator: string = "startswith";
    value: string = " ";
    matchCase: boolean = false;
    waiver;
    combineClaim;
}

export class functionpermission {
    grouppayerservicecreate: boolean = true;
    grouppayerserviceupdate: boolean = true;
    grouppayerservicedelete: boolean = true;
}


